import UnassignPanel from './unassignPanel.container';

export default UnassignPanel;
